export default {
  CALENDLY_REPOSITORY: Symbol.for('CALENDLY_REPOSITORY'),
  GET_SINGLE_USE_SCHEDULE_LINK_QUERY: Symbol.for('GET_SINGLE_USE_SCHEDULE_LINK_QUERY'),
};
